module.exports = __webpack_public_path__ + "static/media/joystick.015e1706.svg";